import React, { useMemo, useState } from "react";
import {
  FaCheckCircle,
  FaClipboardList,
  FaExclamationTriangle,
  FaSearch,
} from "react-icons/fa";
const InventoryTable = ({ data, station }) => {
  const tempDivIItem = data.filter((f) => f.station_code === station);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const categories = [
    "All",
    ...new Set(tempDivIItem.map((item) => item.item_name)),
  ];

  const filteredInventory = useMemo(() => {
    return tempDivIItem.filter((item) => {
      const matchesSearch = item.item_name
        ?.toLowerCase()
        ?.includes(search?.toLowerCase());
      // item.itemCode?.toLowerCase()?.includes(search?.toLowerCase());

      const matchesCategory = category === "All" || item.item_name === category;

      return matchesSearch && matchesCategory;
    });
  }, [search, category]);
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        {/* Table Header */}
        <div className="row g-2 align-items-center mb-3">
          <div className="col-md-5">
            <h6 className="fw-bold mb-0">Inventory Items</h6>

            <small className="text-muted">Complete inventory list</small>
          </div>

          <div className="col-md-4">
            <div className="input-group">
              <span className="input-group-text bg-white">
                <FaSearch />
              </span>

              <input
                type="text"
                className="form-control"
                placeholder="Search item or code..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          <div className="col-md-3">
            <select
              className="form-select"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              {categories.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Category</th>
                <th>Required Qty</th>
                {/* <th>Minimum Qty</th> */}
                <th>Total Qty</th>
                <th>Available</th>
                <th>Defective</th>
                <th>surplus/Short</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredInventory.length > 0 ? (
                filteredInventory.map((item, index) => (
                  <tr key={item.id}>
                    <td className="text-muted">{index + 1}</td>
                    <td>
                      <div className="fw-semibold">{item.item_name}</div>

                      <small className="text-muted">{item.itemCode}</small>
                    </td>

                    <td>
                      <span className="badge bg-light text-dark border">
                        {/* {item.category} */} -
                      </span>
                    </td>
                    <td>{item.required_qty}</td>

                    <td>{item.total_qty}</td>

                    <td>
                      <span className="fw-semibold">{item.available_qty}</span>{" "}
                      {/* <small className="text-muted">{item.defective_qty}</small> */}
                    </td>

                    <td>{item.defective_qty}</td>
                    <td>
                      <b
                        className={`${
                          item.surplus_short_qty > 0
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        {item.surplus_short_qty}
                      </b>
                    </td>
                    <td>
                      {(item.total_qty / item.required_qty) * 100 > 25 && (
                        <span className="badge bg-success-subtle text-success">
                          <FaCheckCircle className="me-1" />
                          In Stock
                        </span>
                      )}
                      {(item.total_qty / item.required_qty) * 100 < 25 && (
                        <span className="badge bg-warning-subtle text-warning-emphasis">
                          <FaExclamationTriangle className="me-1" />
                          Low Stock
                        </span>
                      )}
                      {item.total_qty === 0 && (
                        <span className="badge bg-danger-subtle text-danger">
                          Out of Stock
                        </span>
                      )}
                      <br />
                      <small className="text-muted">
                        {" "}
                        {((item.total_qty / item.required_qty) * 100).toFixed(
                          2,
                        )}
                        %
                      </small>
                    </td>

                    {/* <td>
                      <button className="btn btn-sm btn-outline-primary">
                        View
                      </button>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-5 text-muted">
                    <FaClipboardList size={30} className="mb-2" />

                    <div>No inventory items found</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default InventoryTable;
